module.exports = __webpack_public_path__ + "img/os_logo.9a62f90f.jpeg";